module.exports = __webpack_public_path__ + "static/media/read.cbf49c60.svg";